import type { TFunction } from "i18next";
import type { BudgetLimitErrorResponseV2 } from "../types";
import { isBudgetLimitErrorV2, isOverrideableError } from "../types";

const FAILURE_TYPE_KEYS: Record<string, string> = {
  insufficient_remaining: "errors.insufficient_remaining",
  initial_cash_exhausted: "errors.initial_cash_exhausted",
  allocation_locked: "errors.allocation_locked",
  wrong_category: "errors.wrong_category",
  wrong_project: "errors.wrong_project",
  not_dotted_pot: "errors.not_dotted_pot",
  sum_mismatch: "errors.sum_mismatch",
  no_sources: "errors.no_sources",
  bad_source: "errors.bad_source",
  legacy_section_limit: "errors.legacy_section_limit",
};

export function extractSmetaErrorMessage(errorData: BudgetLimitErrorResponseV2, t: TFunction): string {
  const key = FAILURE_TYPE_KEYS[errorData.failure_type];
  if (!key) return t("errors.unknown");
  return t(key, {
    section: errorData.section ?? "",
    available: errorData.available ?? "0",
    requested: errorData.requested ?? "0",
  });
}

export function handleSmetaError(
  err: unknown,
  opts: {
    tSmeta: TFunction;
    onOverrideable: (errorData: BudgetLimitErrorResponseV2) => void;
    onNonOverrideable: (message: string) => void;
    onFallback: () => void;
  },
): void {
  if (isBudgetLimitErrorV2(err)) {
    const errorData = err.data;
    if (isOverrideableError(errorData)) {
      opts.onOverrideable(errorData);
    } else {
      opts.onNonOverrideable(extractSmetaErrorMessage(errorData, opts.tSmeta));
    }
    return;
  }
  opts.onFallback();
}
